import React, { useEffect, useState } from 'react';
import { NavBar } from '../kuroco/AppBars';
import { AiBubble, DateDivider, UserBubble } from '../kuroco/ChatPrimitives';
import { fetchChatSession } from '../../api/dashboardApi';
import { mapApiSessionDetail } from '../../adapters/kurocoAiData';

export default function AiSessionView({ data, sessionId, onNavigate, settingsPath }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setSession(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchChatSession(sessionId)
      .then((res) => {
        if (!cancelled) {
          setSession(mapApiSessionDetail(res, data.period.today));
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || 'セッションの取得に失敗しました');
          setSession(null);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [sessionId, data.period.today]);

  const fallback = data.aiSessions.find((x) => x.id === sessionId);
  const s = session || fallback;

  if (loading && !s) {
    return (
      <div className="ai-screen">
        <NavBar title="読み込み中…" backLabel="履歴" onBack={() => onNavigate('aihistory')} settingsPath={settingsPath} />
      </div>
    );
  }

  if (!s) {
    return (
      <div className="ai-screen">
        <NavBar title="セッション" backLabel="履歴" onBack={() => onNavigate('aihistory')} settingsPath={settingsPath} />
        <div className="scroll fade">
          <div className="databanner">{error || 'セッションが見つかりません'}</div>
        </div>
      </div>
    );
  }

  const count = s.messages?.length || s.message_count || 0;

  return (
    <div className="ai-screen">
      <NavBar title={s.title} backLabel="履歴" onBack={() => onNavigate('aihistory')} settingsPath={settingsPath} />
      <div className="chat-banner">
        <span className="chat-banner-ic">{s.icon}</span>
        <div>
          <div className="chat-banner-t">{s.title}</div>
          <div className="chat-banner-s">
            {s.dateLabel} {s.time} · {count}件のやり取り
          </div>
        </div>
      </div>
      <div className="chat-scroll fade">
        <DateDivider label={s.dateLabel} />
        {(s.messages || []).map((m, i) =>
          m.role === 'user' ? (
            <UserBubble key={i} text={m.text} time={s.time} wrap />
          ) : (
            <AiBubble key={i} text={m.text} time={s.time} />
          )
        )}
        <div className="sess-ended">— この相談はここまで —</div>
      </div>
      <div className="sess-foot">
        <button type="button" className="sess-continue" onClick={() => onNavigate('home', sessionId)}>
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" aria-hidden="true">
            <path
              d="M21 14a2 2 0 01-2 2H8l-4 4V5a2 2 0 012-2h13a2 2 0 012 2z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          この続きから相談する
        </button>
      </div>
    </div>
  );
}
